var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("vue-loading", {
        attrs: {
          active: _vm.loading,
          "is-full-page": true,
          loader: "dots",
          color: "#70A1F0"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    : _c(
        "div",
        { staticClass: "box", attrs: { id: "management" } },
        [
          _c("transition", { attrs: { name: "fade", appear: "" } }, [
            _c("div", [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col" },
                  [
                    _c("h4", [_vm._v("Groups")]),
                    _vm._v(" "),
                    _vm._l(_vm.groupList, function(group, index) {
                      return _c(
                        "form",
                        {
                          key: "groups-" + index,
                          attrs: { id: "group-form-" + index },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.updateGroup(index)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.groupList[index],
                                      expression: "groupList[index]"
                                    }
                                  ],
                                  staticClass: "form-control details-input",
                                  class: _vm.getSavingClass("group-" + index),
                                  attrs: {
                                    type: "text",
                                    id: "group-" + index,
                                    required: ""
                                  },
                                  domProps: { value: _vm.groupList[index] },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.groupList,
                                        index,
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _c(
                                  "button",
                                  { staticClass: "btn btn-primary" },
                                  [_vm._v("Save")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.delGroup(index)
                                      }
                                    }
                                  },
                                  [_vm._v("Delete")]
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.addGroup()
                            }
                          }
                        },
                        [_vm._v("Add Group")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("h4", [_vm._v("Accounts")]),
                    _vm._v(" "),
                    _vm._l(_vm.accounts, function(account, index) {
                      return _c(
                        "form",
                        {
                          key: "accounts-" + index,
                          attrs: { id: "account-form-" + index },
                          on: {
                            submit: function($event) {
                              $event.preventDefault()
                              return _vm.updateAccount(index)
                            }
                          }
                        },
                        [
                          _c("div", { staticClass: "form-group" }, [
                            _c("div", { staticClass: "form-row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.accounts[index].id,
                                      expression: "accounts[index].id"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.getSavingClass(
                                    "accounts-" + index
                                  ),
                                  attrs: {
                                    type: "text",
                                    id: "accountId-" + index,
                                    minlength: "12",
                                    maxlength: "12",
                                    placeholder: "account id",
                                    required: ""
                                  },
                                  domProps: { value: _vm.accounts[index].id },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.accounts[index],
                                        "id",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.accounts[index].name,
                                      expression: "accounts[index].name"
                                    }
                                  ],
                                  staticClass: "form-control",
                                  class: _vm.getSavingClass(
                                    "accounts-" + index
                                  ),
                                  attrs: {
                                    type: "text",
                                    id: "accountName-" + index,
                                    placeholder: "account name",
                                    required: ""
                                  },
                                  domProps: { value: _vm.accounts[index].name },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.$set(
                                        _vm.accounts[index],
                                        "name",
                                        $event.target.value
                                      )
                                    }
                                  }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-xs" }, [
                                _c(
                                  "button",
                                  { staticClass: "btn btn-primary" },
                                  [_vm._v("Save")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.delAccount(index)
                                      }
                                    }
                                  },
                                  [_vm._v("Delete")]
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-success",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.addAccount()
                            }
                          }
                        },
                        [_vm._v("Add Account")]
                      )
                    ])
                  ],
                  2
                ),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("h4", [_vm._v("Slack")]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: { id: "slack" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.updateContractDetails("slack")
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.slack_team_id,
                              expression: "slack_team_id"
                            }
                          ],
                          staticClass: "form-control text-input",
                          class: _vm.getSavingClass("slack"),
                          attrs: {
                            type: "text",
                            id: "slackTeamId",
                            placeholder: "slack team id"
                          },
                          domProps: { value: _vm.slack_team_id },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.slack_team_id = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("button", { staticClass: "btn btn-primary" }, [
                          _vm._v("Update Slack Team")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Channel")]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: { id: "channel" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.updateContractDetails("channel")
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.channel_id,
                              expression: "channel_id"
                            }
                          ],
                          staticClass: "form-control text-input",
                          class: _vm.getSavingClass("channel"),
                          attrs: {
                            type: "text",
                            id: "channelId",
                            placeholder: "channel id"
                          },
                          domProps: { value: _vm.channel_id },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.channel_id = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("button", { staticClass: "btn btn-primary" }, [
                          _vm._v("Update Channel ID")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Zendesk")]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: { id: "channel" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.updateContractDetails("zendesk")
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.zendesk_group_id,
                              expression: "zendesk_group_id"
                            }
                          ],
                          staticClass: "form-control text-input",
                          class: _vm.getSavingClass("zendesk"),
                          attrs: {
                            type: "text",
                            id: "zendeskGroupId",
                            placeholder: "zendesk group id"
                          },
                          domProps: { value: _vm.zendesk_group_id },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.zendesk_group_id = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("button", { staticClass: "btn btn-primary" }, [
                          _vm._v("Update Zendesk Group ID")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Trello")]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      ref: "formContainer",
                      attrs: { id: "trello" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.updateContractDetails("trello")
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._l(_vm.trello_board_ids, function(board, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                attrs: { id: "trello-inputs-" + index }
                              },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "10px" } },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.trello_board_ids[index],
                                          expression: "trello_board_ids[index]"
                                        }
                                      ],
                                      staticClass: "form-control details-input",
                                      class: _vm.getSavingClass("trello"),
                                      attrs: {
                                        type: "text",
                                        id: "trelloTeamId-" + index,
                                        placeholder: "trello board id",
                                        required: ""
                                      },
                                      domProps: {
                                        value: _vm.trello_board_ids[index]
                                      },
                                      on: {
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.$set(
                                            _vm.trello_board_ids,
                                            index,
                                            $event.target.value
                                          )
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-danger trello-remove-btn",
                                        attrs: { type: "button" },
                                        on: {
                                          click: function($event) {
                                            return _vm.delTrelloBoard(index)
                                          }
                                        }
                                      },
                                      [_vm._v("Delete")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: { clear: "both" }
                                    })
                                  ]
                                )
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c("button", { staticClass: "btn btn-primary" }, [
                              _vm._v("Update Boards")
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.addTrelloBoard()
                                  }
                                }
                              },
                              [_vm._v("Add")]
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c("h4", [_vm._v("OpsGenie Alternitive Integration Names")]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: { id: "opsGenie" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.updateContractDetails("opsgenie")
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "form-group" },
                        [
                          _vm._l(_vm.opsgenie_alt, function(alt, index) {
                            return _c("div", { key: index }, [
                              _c(
                                "div",
                                { staticStyle: { "margin-bottom": "10px" } },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.opsgenie_alt[index],
                                        expression: "opsgenie_alt[index]"
                                      }
                                    ],
                                    staticClass: "form-control details-input",
                                    class: _vm.getSavingClass("opsgenie"),
                                    attrs: {
                                      type: "text",
                                      id: "opsGenieAlt-" + index,
                                      placeholder: "alternative name",
                                      required: ""
                                    },
                                    domProps: {
                                      value: _vm.opsgenie_alt[index]
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.opsgenie_alt,
                                          index,
                                          $event.target.value
                                        )
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-danger trello-remove-btn",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.delOpsGenieAlt(index)
                                        }
                                      }
                                    },
                                    [_vm._v("Delete")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticStyle: { clear: "both" } })
                                ]
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c("button", { staticClass: "btn btn-primary" }, [
                              _vm._v("Update OpsGenie")
                            ]),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    return _vm.addOpsGenieAlt()
                                  }
                                }
                              },
                              [_vm._v("Add")]
                            )
                          ])
                        ],
                        2
                      )
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("h4", [_vm._v("Jira Boards")]),
                  _vm._v(" "),
                  _c(
                    "form",
                    {
                      attrs: { id: "jira" },
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.updateContractDetails("jira")
                        }
                      }
                    },
                    [
                      _vm._l(_vm.jira_boards, function(jboard, jboardindex) {
                        return _c("div", { key: "jboard" + jboardindex }, [
                          _c("div", { staticClass: "form-group" }, [
                            _c("label", { attrs: { for: "jiraBoardId" } }, [
                              _vm._v("Board Id")
                            ]),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.jira_boards[jboardindex].board_id,
                                  expression:
                                    "jira_boards[jboardindex].board_id"
                                }
                              ],
                              staticClass: "form-control",
                              class: _vm.getSavingClass("jira"),
                              staticStyle: { "max-width": "300px" },
                              attrs: {
                                type: "text",
                                id: "jiraBoardId-" + jboardindex,
                                required: ""
                              },
                              domProps: {
                                value: _vm.jira_boards[jboardindex].board_id
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.jira_boards[jboardindex],
                                    "board_id",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-group" }, [
                            _c(
                              "label",
                              { attrs: { for: "jiraInstanceName" } },
                              [_vm._v("Instance Name")]
                            ),
                            _vm._v(" "),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value:
                                    _vm.jira_boards[jboardindex].instance_name,
                                  expression:
                                    "jira_boards[jboardindex].instance_name"
                                }
                              ],
                              staticClass: "form-control",
                              class: _vm.getSavingClass("jira"),
                              staticStyle: { "max-width": "300px" },
                              attrs: {
                                type: "text",
                                id: "jiraInstanceName-" + jboardindex,
                                required: ""
                              },
                              domProps: {
                                value:
                                  _vm.jira_boards[jboardindex].instance_name
                              },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.jira_boards[jboardindex],
                                    "instance_name",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "jiraPlannedLists" } },
                                [_vm._v("Planned Lists")]
                              ),
                              _vm._v(" "),
                              _vm._l(jboard.planned_lists, function(
                                planned,
                                index
                              ) {
                                return _c("div", { key: index }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "margin-bottom": "10px" }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: jboard.planned_lists[index],
                                            expression:
                                              "jboard.planned_lists[index]"
                                          }
                                        ],
                                        staticClass:
                                          "form-control details-input",
                                        class: _vm.getSavingClass("jira"),
                                        attrs: {
                                          type: "text",
                                          id: "jiraPlannedLists-" + index
                                        },
                                        domProps: {
                                          value: jboard.planned_lists[index]
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              jboard.planned_lists,
                                              index,
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-danger details-remove-btn",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.delJiraPlannedLists(
                                                jboard,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: { clear: "both" }
                                      })
                                    ]
                                  )
                                ])
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addJiraPlannedLists(jboard)
                                      }
                                    }
                                  },
                                  [_vm._v("Add")]
                                )
                              ])
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form-group" },
                            [
                              _c(
                                "label",
                                { attrs: { for: "jiraInProgressLists" } },
                                [_vm._v("In Progress Lists")]
                              ),
                              _vm._v(" "),
                              _vm._l(jboard.in_progress_lists, function(
                                progress,
                                index
                              ) {
                                return _c("div", { key: index }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: { "margin-bottom": "10px" }
                                    },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              jboard.in_progress_lists[index],
                                            expression:
                                              "jboard.in_progress_lists[index]"
                                          }
                                        ],
                                        staticClass:
                                          "form-control details-input",
                                        class: _vm.getSavingClass("jira"),
                                        attrs: {
                                          type: "text",
                                          id: "jiraInProgressLists-" + index
                                        },
                                        domProps: {
                                          value: jboard.in_progress_lists[index]
                                        },
                                        on: {
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              jboard.in_progress_lists,
                                              index,
                                              $event.target.value
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "button",
                                        {
                                          staticClass:
                                            "btn btn-danger details-remove-btn",
                                          attrs: { type: "button" },
                                          on: {
                                            click: function($event) {
                                              return _vm.delJiraInProgressLists(
                                                jboard,
                                                index
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("Delete")]
                                      ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: { clear: "both" }
                                      })
                                    ]
                                  )
                                ])
                              }),
                              _vm._v(" "),
                              _c("div", [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-success",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.addJiraInProgressLists(
                                          jboard
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("Add")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticStyle: { "margin-top": "10px" } },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-danger",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.delJiraBoard(jboardindex)
                                        }
                                      }
                                    },
                                    [_vm._v("Delete Jira Board")]
                                  )
                                ]
                              )
                            ],
                            2
                          )
                        ])
                      }),
                      _vm._v(" "),
                      _c("div", [
                        _c("button", { staticClass: "btn btn-primary" }, [
                          _vm._v("Update Jira Boards")
                        ]),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            attrs: { type: "button" },
                            on: {
                              click: function($event) {
                                return _vm.addJiraBoard()
                              }
                            }
                          },
                          [_vm._v("Add Jira Board")]
                        )
                      ])
                    ],
                    2
                  )
                ])
              ])
            ])
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9820c9b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9820c9b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ContractModify.vue
// module id = null
// module chunks = 